import { WorkcellMode } from '@automata/api/apiSchemas';
import { colors } from '@automata/mui-theme';
import { Typography } from '@automata/ui';
import { logger } from '@automata/utils';

export type Props = {
  workcellMode: WorkcellMode;
};

const getWorkcellModeColor = (workcellMode: WorkcellMode) => {
  const { semantic } = colors;

  switch (workcellMode) {
    case 'active':
      return semantic.info.main;
    case 'validating':
      return semantic.warning.main;
    case 'maintenance':
      return semantic.error.main;
    default:
      logger.warn(`Unknown workcell mode: ${workcellMode}`);
      return semantic.info.main;
  }
};

export const WorkcellModeIndicator = ({ workcellMode }: Props): JSX.Element => {
  return (
    <Typography
      variant="body2"
      color={getWorkcellModeColor(workcellMode)}
      sx={{
        textTransform: 'capitalize',
      }}
    >
      {workcellMode}
    </Typography>
  );
};

export default WorkcellModeIndicator;
